// Simple fetch-based API client to avoid webpack issues
const API_BASE_URL = "https://api.adsign.adactive.asia";

// Create a simple API client
const apiClient = {
  get: async (url, options = {}) => {
    const token = localStorage.getItem("authToken");
    const headers = {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    };

    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: "GET",
      headers,
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { data: await response.json() };
  },

  post: async (url, data = null, options = {}) => {
    const token = localStorage.getItem("authToken");

    // Check if data is FormData (for file uploads)
    const isFormData = data instanceof FormData;

    const headers = {
      // Only set Content-Type for JSON, let browser handle FormData
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    };

    console.log("POST Request to:", `${API_BASE_URL}${url}`);
    console.log("With data:", data);
    console.log("With headers:", headers);

    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: "POST",
      headers,
      // Use data directly for FormData, stringify for JSON
      body: data ? (isFormData ? data : JSON.stringify(data)) : null,
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { data: await response.json() };
  },

  patch: async (url, data = null, options = {}) => {
    const token = localStorage.getItem("authToken");
    const headers = {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    };

    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: "PATCH",
      headers,
      body: data ? JSON.stringify(data) : null,
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { data: await response.json() };
  },
};

export default apiClient;
